import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import actions from 'state/actions';
import services from 'services';
import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';

const SplitAndFix = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const history = useHistory();
  const docIds = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const [errorProtocols, setErrorProtocols] = useState<number[]>([]);
  const [visbility, setErrorModal] = useState(false);
  const [ErrorModal] = utils.hooks.useBulkActionErrorModal(errorProtocols, visbility);

  const onConfirm = async () => {
    try {
      const { data } = await services.splitAndFix({
        documentToDistributeList: docIds,
      });
      let protocolArrToBeMoved = [...docIds];
      if (!data.success) {
        setErrorProtocols(data.protocols);
        setErrorModal(true);
        protocolArrToBeMoved = protocolArrToBeMoved.filter((protocol) => !errorProtocols.includes(protocol));
        utils.app.notify('warning', t('split-fix-warning'));
        dispatch(actions.documents.removeRows(protocolArrToBeMoved));
      } else {
        dispatch(actions.modal.closeModal());
        utils.app.notify('success', t('file-moved'));
        dispatch(actions.documents.removeRows(protocolArrToBeMoved));
        if (utils.documents.isOpenDocumentView()) dispatch(actions.documents.openNextDocument(history));
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {visbility ? (
        <ErrorModal />
      ) : (
        <>
          <Modal.Header title={t('split-fix-title')} subtitle={t('split-fix-text')} />
          <Modal.Footer
            confirmText={t('continua')}
            confirmAction={onConfirm}
            closeButtonText={t('annulla')}
          />
        </>
      )}
    </>
  );
};

export default SplitAndFix;
